
import React from 'react';
import { motion } from 'framer-motion';
import { FileCheck, Settings, Rocket } from 'lucide-react';

const PartnerProcess = () => {
  const steps = [
    {
      icon: FileCheck,
      title: "Apply & Qualify",
      description: "We vet your patient base, ops, and goals."
    },
    {
      icon: Settings,
      title: "We Set Up Everything", 
      description: "Licensing, staff, equipment, signage, training, and protocols."
    },
    {
      icon: Rocket,
      title: "Launch & Profit",
      description: "Your patients start booking. You earn revenue every month."
    }
  ];

  return (
    <section className="py-32 bg-white">
      <div className="container mx-auto px-6 max-w-7xl">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="text-center mb-20"
        >
          <h2 className="text-5xl md:text-6xl font-serif font-light text-juv-deep-chestnut mb-6">
            How It Works
          </h2>
          <p className="text-2xl text-juv-deep-chestnut/70">
            From Zero to Fully Active in 30 Days
          </p>
        </motion.div>

        <div className="grid md:grid-cols-3 gap-12">
          {steps.map((step, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6, delay: index * 0.2 }}
              className="text-center relative"
            >
              {index < steps.length - 1 && (
                <div className="hidden md:block absolute top-16 -right-6 w-12 h-px bg-juv-terracotta/30" />
              )}
              
              <div className="w-20 h-20 bg-juv-terracotta rounded-full flex items-center justify-center mx-auto mb-8">
                <step.icon className="w-10 h-10 text-white" />
              </div>
              
              <div className="absolute -top-2 left-1/2 transform -translate-x-1/2 w-8 h-8 bg-juv-rose-clay rounded-full flex items-center justify-center text-white font-bold">
                {index + 1}
              </div>
              
              <h3 className="text-2xl font-semibold text-juv-deep-chestnut mb-4">
                {step.title}
              </h3>
              
              <p className="text-lg text-juv-deep-chestnut/70 leading-relaxed">
                {step.description}
              </p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default PartnerProcess;
